import { createContext } from "react";

export type ReadinessState = {
  uid: string | null;
  status: "checking" | "complete" | "incomplete" | "error";
  displayName: string;
  birthDate?: Date | null;
  errorMessage?: string;
};
export const AccountReadinessContext = createContext<(ReadinessState & { refresh: () => Promise<void> }) | null>(null);
